/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Hero_Mode_CoachInputs */

const en_portal_hero_mode_coach = /** @type {(inputs: Portal_Hero_Mode_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With a coach`)
};

const pl_portal_hero_mode_coach = /** @type {(inputs: Portal_Hero_Mode_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z trenerem`)
};

/**
* | output |
* | --- |
* | "With a coach" |
*
* @param {Portal_Hero_Mode_CoachInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_hero_mode_coach = /** @type {((inputs?: Portal_Hero_Mode_CoachInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Hero_Mode_CoachInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_hero_mode_coach(inputs)
	return en_portal_hero_mode_coach(inputs)
});